import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../../core/state/shared/root-state.interface';
import {
  selectAlertMessage,
  selectIsLoading,
} from '../../../core/state/user-session/user-session.selectors';
import {
  authenticateAndPair,
  dismissAlert,
} from '../../../core/state/user-session/user-session.actions';
import { TokenExpirationService } from '../../../core/services/token-expiration.service';
import { ActivatedRoute } from '@angular/router';
import { ActablProductNames } from '../../../core/models/user-profile.model';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatHint, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pairing-form',
  templateUrl: './pairing-form.component.html',
  styleUrls: [
    './pairing-form.component.scss',
    '../pairing.component.scss',
    '../../login-form/login-form.component.scss',
  ],
  imports: [
    MatIcon,
    MatIconButton,
    FormsModule,
    MatFormField,
    MatInput,
    MatHint,
    MatSuffix,
    MatButton,
    AsyncPipe,
    TranslateModule,
  ],
})
export class PairingFormComponent implements OnInit {
  username: string;
  password: string;
  alertMessage$: Observable<{ message: string; hasError: boolean }>;
  isLoading$: Observable<boolean>;
  showPassword = false;
  token: string;

  private store = inject(Store<RootState>);
  private route = inject(ActivatedRoute);
  private tokenExpirationService = inject(TokenExpirationService);

  ngOnInit() {
    this.alertMessage$ = this.store.pipe(select(selectAlertMessage));
    this.isLoading$ = this.store.pipe(select(selectIsLoading));
    this.token = this.route.snapshot.queryParams['token'];
  }

  onSubmit() {
    this.tokenExpirationService.clearTokenTimer();
    this.store.dispatch(
      authenticateAndPair({
        username: this.username,
        password: this.password,
        token: this.token,
      }),
    );
  }

  hideAlert() {
    this.store.dispatch(dismissAlert());
  }

  protected readonly ActablProductNames = ActablProductNames;
}
